"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Badge.default;
  }
});

var _Badge = _interopRequireDefault(require("./Badge"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Badge/index.js
// module id = 720
// module chunks = 0